import React from 'react';
import { FinancialTransaction } from '../../services/database/supabase';
import { FinancialAlerts } from './FinancialAlerts';
import { CashFlowChart } from './CashFlowChart';

interface FinancialAnalysisProps {
  transactions: FinancialTransaction[];
  isBlurred: boolean;
}

export const FinancialAnalysis: React.FC<FinancialAnalysisProps> = ({
  transactions,
  isBlurred
}) => {
  return (
    <div className="space-y-8">
      {/* Alertas e Relatórios */}
      <FinancialAlerts
        transactions={transactions}
        isBlurred={isBlurred}
      />

      {/* Gráficos */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Fluxo de Caixa */}
        <div className="bg-[#111]/50 p-6 rounded-xl">
          <h3 className="font-medium mb-6">Fluxo de Caixa</h3>
          <CashFlowChart transactions={transactions} />
        </div>

        {/* Distribuição por Categoria */}
        <div className="bg-[#111]/50 p-6 rounded-xl">
          <h3 className="font-medium mb-6">Distribuição por Categoria</h3>
          <div className="aspect-square">
            {/* Adicione aqui um gráfico de pizza por categoria */}
          </div>
        </div>
      </div>

      {/* Análise de Tendências */}
      <div className="bg-[#111]/50 p-6 rounded-xl">
        <h3 className="font-medium mb-6">Tendências de Gastos</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Top Categorias */}
          <div>
            <h4 className="text-sm text-white/60 mb-4">Top Categorias</h4>
            {/* Lista das categorias mais frequentes */}
          </div>

          {/* Maiores Gastos */}
          <div>
            <h4 className="text-sm text-white/60 mb-4">Maiores Gastos</h4>
            {/* Lista dos maiores gastos */}
          </div>

          {/* Economia Mensal */}
          <div>
            <h4 className="text-sm text-white/60 mb-4">Economia Mensal</h4>
            {/* Gráfico ou indicador de economia */}
          </div>
        </div>
      </div>
    </div>
  );
};
